<!-- src/views/DecryptorView.vue -->
<template>
  <div class="decryptor-container">
    <img src="@/assets/decryptor-icon.png" alt="Decryptor icon" class="app-icon" />
    <h1 class="decryptor-title">Decryption Utility for macOS</h1>
    <p class="tagline">Drag, drop, and unlock.</p>

    <ul class="key-props">
      <li>Lightning-fast workflow – drag-and-drop or paste a URL; Decryptor streams the plaintext out instantly.</li>
      <li>No guesswork – accepts Base-64 or C-style escaped keys/IVs and shows human-readable error messages.</li>
    </ul>

    <p class="short-promo">
      Decryption Utility is the quickest way to open files locked with AES-256-CBC. Drop the file, paste your key + IV, and you’re done.
    </p>
    <p class="full-description">
      Need to inspect an encrypted log, retrieve a forgotten backup, or QA a secure payload? Decryptor eliminates command-line gymnastics. Built in Swift with CryptoKit/CryptoSwift, it works entirely offline—perfect for developers, IT admins, and security researchers.
    </p>

    <h2 class="features-header">Features</h2>
    <ul class="features-list">
      <li>Drag-and-drop or URL download</li>
      <li>Base-64 and escaped-byte key formats</li>
      <li>Auto-generated light/dark app icons</li>
    </ul>

    <h2 class="features-header">Privacy & Encryption</h2>
    <p class="privacy-text">
      We do not collect anything. All processing stays on-device and every operation runs locally on your Mac.
    </p>

    <p class="compliance-text">
      Decryption Utility uses standard AES-256-CBC decryption under EAR 5D992.c (mass-market exemption). No encryption, networking crypto, or proprietary algorithms are included.
    </p>

    <div class="badge-wrapper">
      <a href="https://apps.apple.com" target="_blank" rel="noopener">
        <img src="@/assets/app-store-badge.png" alt="Download on the App Store" class="app-store-badge" />
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DecryptorView',
});
</script>

<style scoped>
.decryptor-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  line-height: 1.6;
  color: #444;
  text-align: center;
}

.app-icon {
  width: 120px;
  height: 120px;
  margin-bottom: 10px;
}

.decryptor-title {
  font-size: 2.5rem;
  margin-bottom: 10px;
}

.tagline {
  font-size: 1.5rem;
  margin-bottom: 20px;
}

.key-props {
  text-align: left;
  margin-bottom: 20px;
}

.key-props li {
  margin-bottom: 8px;
}

.short-promo,
.full-description {
  text-align: left;
  margin-bottom: 20px;
}

.features-header {
  font-size: 1.8rem;
  margin-top: 20px;
}

.features-list {
  text-align: left;
  margin-bottom: 20px;
}

.features-list li {
  margin-bottom: 8px;
}

.privacy-text,
.compliance-text {
  font-size: 0.9rem;
  margin-top: 20px;
  text-align: left;
}

.badge-wrapper {
  margin-top: 30px;
}

.app-store-badge {
  width: 200px;
  height: auto;
}
</style>
